import PrintStationClient from './print-client';

export async function generateStaticParams() {
  return [{ id: 'placeholder' }];
}

export default function PrintStationPage() {
  return <PrintStationClient />;
}
